import { Component, OnInit } from '@angular/core';
import { DialogRef } from '@fundamental-ngx/core/dialog';
import { CheckboxModel } from '../../../core/models/misc/checkbox.model';
import { FilterItemModel } from '../../../core/models/misc/filter-item.model';

@Component({
    selector: 'app-filter-dialog',
    templateUrl: './filter-dialog.component.html',
    styleUrls: ['./filter-dialog.component.scss'],
    standalone: false
})
export class FilterDialogComponent implements OnInit {
    displayedValues: CheckboxModel[];
    originalDisplayValues: CheckboxModel[];
    currentFilters: FilterItemModel[] = [];
    property: string;
    isAllChecked: boolean;
    title: string;
    searchTerm: string;

    constructor(public _dialogRef: DialogRef) {}

    ngOnInit(): void {
        this.currentFilters = this._dialogRef.data.currentFilters;
        this.property = this._dialogRef.data.property;
        this.title = `Filter By: ${this._dialogRef.data.title}`;
        this.init(this._dialogRef.data.values, this.currentFilters, this.property);
        this.onCheckboxChange();
    }

    init(values: any[], currentFilters: FilterItemModel[], property: string) {
        let filteredValues = this.filterValues(values, currentFilters, property);
        this.displayedValues = this.generateDisplayedValues(filteredValues, currentFilters, property);
        this.originalDisplayValues = this.displayedValues.map((item: CheckboxModel) =>
            Object.assign(new CheckboxModel(), item)
        );
    }

    generateDisplayedValues(filteredValues: any[], currentFilters: FilterItemModel[], property: string) {
        const splitProperties: string[] = property.split('.');
        return (
            filteredValues
                .map((policy) => {
                    let res = policy;
                    splitProperties.forEach((prop) => {
                        res = this.isEmptyObject(res[prop]) ? '' : res[prop];
                    });

                    let isFilteredByProperty = currentFilters.some((item) => item.filterProperty === property);

                    return new CheckboxModel({
                        value: res,
                        checked: isFilteredByProperty
                            ? currentFilters.some((item) => item.filterValues?.some((item) => item === res))
                            : true,
                    });
                })
            //Filter duplicates
                .filter((value, index, self) => index === self.findIndex((t) => t.value === value.value))
        );
    }

    isEmptyObject(value: any): boolean {
        return value && typeof value === 'object' && Object.keys(value).length === 0 && value.constructor === Object;
    }

    filterValues(values: any[], currentFilters: FilterItemModel[], property: string): any[] {
        currentFilters.forEach((filterItem) => {
            if (property !== filterItem.filterProperty) {
                const splitProperties: string[] = filterItem.filterProperty.split('.');
                values = values.filter((x) => {
                    let res = x;
                    splitProperties.forEach((prop) => {
                        res = res[prop];
                    });
                    return filterItem.filterValues.includes(res);
                });
            }
        });
        return values || [];
    }

    onSelectAll(event: any) {
        if (event.target.checked) {
            this.displayedValues.forEach((item) => (item.checked = true));
        } else {
            this.displayedValues.forEach((item) => (item.checked = false));
        }
    }

    onCheckboxChange() {
        this.isAllChecked = this.isAllValuesChecked();
    }

    isAllValuesChecked() {
        return this.displayedValues.every((item) => item.checked);
    }

    isValid() {
        const hasSearchTerm = this.searchTerm && this.searchTerm.length > 0;
        let values = this.displayedValues || [];
        if(hasSearchTerm) {
            values = this.displayedValues.filter((x) => x.value.toLowerCase().includes(this.searchTerm.toLowerCase()));
        }
        return values.some((item) => item.checked);
    }

    hasChanges() {
        return !(
            this.displayedValues.length === this.originalDisplayValues.length &&
			this.displayedValues.every((val, index) => val.checked === this.originalDisplayValues[index].checked)
        );
    }

    doSearch(event: any) {
        this.searchTerm = event;
    }

    onSubmit() {
        let filterItems = this.currentFilters;
        const hasSearchTerm = this.searchTerm && this.searchTerm.length > 0;
        if (this.hasChanges() || hasSearchTerm) {
            let isFiltered = !this.isAllValuesChecked();
            filterItems = filterItems.filter((item) => item.filterProperty !== this.property);
            if(hasSearchTerm) {
                filterItems.push(
                    new FilterItemModel({
                        filterValues: this.displayedValues.filter((x) => x.value.toLowerCase().includes(this.searchTerm.toLowerCase())).map((item) => item.value),
                        filterProperty: this.property,
                    })
                );
            }
            if (isFiltered) {
                filterItems.push(
                    new FilterItemModel({
                        filterValues: this.displayedValues.filter((x) => x.checked).map((item) => item.value),
                        filterProperty: this.property,
                    })
                );
            }
        }

        this._dialogRef.close({
            filterItems: filterItems.map((item: FilterItemModel) => Object.assign(new FilterItemModel(), item)),
        });
    }
}
